import { chargersWizardData } from './chargers';
import { gen3WizardData } from './gen3Rings';
import type { WizardData } from './types';

const wizardData: WizardData = {
  ...chargersWizardData,
  ...gen3WizardData,
};

export default wizardData;
